"use client";

import cn from "classnames";

import { FA } from "@/shared/components/ui/icon/FA";
import type { FontAwesomeIcon, FontAwesomeTheme } from "@/shared/components/ui/icon/fa.types";
import { normalizeButtonVariant } from "../shared/buttonVariants";
import type { CustomButtonAttrs } from "./customButton.types";
import s from "./CustomButton.module.scss";

interface Props {
  attrs: CustomButtonAttrs;
}

const VARIANT_CLASS: Record<string, string> = {
  white: s.white,
  outlined: s.outlined,
  primary: s.primary,
  accent: s.accent,
  cta: s.primary, // backwards compat
};

export const CustomButton = ({ attrs }: Props) => {
  const { href, title, variant, icon, iconTheme, iconPosition } = attrs;
  const normalized = normalizeButtonVariant(variant);
  const iconEl = icon ? (
    <FA
      icon={icon as FontAwesomeIcon}
      theme={(iconTheme || "fad") as FontAwesomeTheme}
      className={s.icon}
      color={normalized === "white" ? "primary" : undefined}
    />
  ) : null;

  return (
    <a
      href={href || undefined}
      className={cn(
        s.button,
        VARIANT_CLASS[normalized] || s.white,
        "custom-button",
        `custom-button--${normalized}`
      )}
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      {iconPosition === "prefix" && iconEl}
      {title || "Button"}
      {iconPosition === "suffix" && iconEl}
    </a>
  );
};
